import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Raven from 'raven-js';

import './index.css';
import 'sanitize.css';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/bouncyflip.css';

import App from './containers/App';
import ScrollToTop from './containers/ScrollToTop';
import * as serviceWorker from './serviceWorker';

Raven.config('https://e8dc8da6e0974a23b644dc07ada51789@sentry.life.ru/212', {
  release: process.env.REACT_APP_VERSION,
  environment: process.env.NODE_ENV,
  whitelistUrls: [/baza.io/],
}).install();

ReactDOM.render((
  <BrowserRouter>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </BrowserRouter>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

// eslint-disable-next-line
console.log(`version: ${process.env.REACT_APP_VERSION}, branch: ${process.env.REACT_APP_BRANCH}`);
